import { MessageCircle } from 'lucide-react';

export const WhatsAppButton = () => {
  const phoneNumber = "33753202093";
  const message = "Bonjour, je souhaite réserver un VTC YOUMI GREEN.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BA5C] text-white p-4 rounded-full shadow-lg transition-transform hover:scale-110 flex items-center gap-2 group"
      data-testid="whatsapp-button"
    >
      <MessageCircle className="w-6 h-6 fill-current" />
      <span className="max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-300 whitespace-nowrap font-medium">
        WhatsApp
      </span>
    </a>
  );
};
